import AppClearbitIcon from '~/images/sidebar/AppClearbit.svg';
import AppXIcon from '~/images/sidebar/AppX.svg';
import GoIcon from '~/images/sidebar/Go.svg';
import IntegrationHubspotIcon from '~/images/sidebar/IntegrationHubspot.svg';
import IntegrationMarketoIcon from '~/images/sidebar/IntegrationMarketo.svg';
import IntegrationSalesforceIcon from '~/images/sidebar/IntegrationSalesforce.svg';
import IntegrationSegmentIcon from '~/images/sidebar/IntegrationSegment.svg';

import styles from './styles';

const appNames = {
  x: 'x',
  clearbit: 'clearbit',
  salesforce: 'salesforce',
  marketo: 'marketo',
  segment: 'segment',
  hubspot: 'hubspot',
};

const APPS = [
  {
    name: appNames.x,
    title: 'Clearbit X',
    text: 'x.clearbit.com',
    link: '#',
    current: true,
  },
  {
    name: appNames.clearbit,
    title: 'Clearbit',
    text: 'dashboard.clearbit.com',
    link: 'https://dashboard.clearbit.com/',
    current: false,
  },
];

const INTEGRATIONS = [
  {
    name: appNames.salesforce,
    title: 'Clearbit for Salesforce',
    text: 'Salesforce App Exchange',
    link:
      'https://appexchange.salesforce.com/appxListingDetail?listingId=a0N30000000q4RNEAY',
    current: false,
  },
  {
    name: appNames.marketo,
    title: 'Clearbit for Marketo',
    text: 'marketo.clearbit.com',
    link: 'https://marketo.clearbit.com/',
    current: false,
  },
  {
    name: appNames.segment,
    title: 'Clearbit for Segment',
    text: 'segment.clearbit.com',
    link: 'https://segment.clearbit.com/',
    current: false,
  },
  {
    name: appNames.hubspot,
    title: 'Clearbit for Hubspot',
    text: 'hubspot.clearbit.com',
    link: 'https://hubspot.clearbit.com/',
    current: false,
  },
];

const Icon = ({ appName, className, ...props }) => {
  switch (appName) {
    case appNames.x:
      return <AppXIcon className={className} {...props} />;
    case appNames.clearbit:
      return <AppClearbitIcon className={className} {...props} />;
    case appNames.salesforce:
      return <IntegrationSalesforceIcon className={className} {...props} />;
    case appNames.marketo:
      return <IntegrationMarketoIcon className={className} {...props} />;
    case appNames.segment:
      return <IntegrationSegmentIcon className={className} {...props} />;
    case appNames.hubspot:
      return <IntegrationHubspotIcon className={className} {...props} />;
  }
};

const AppLink = ({ app, classes }) => (
  <div className={classes.app}>
    <div className={classes.appDetailContainer}>
      <Icon className={classes.appIcon} appName={app.name} />
      <div className={classes.appDetail}>
        <span className={classes.appTitle}>{app.title}</span>
        <span className={classes.appLinkText}>{app.text}</span>
      </div>
    </div>
    {app.current ? (
      <div className={classes.currentTag}>Current</div>
    ) : (
      <GoIcon className={classes.arrow} />
    )}
  </div>
);

const AppSwitch = ({ classes }) => {
  return (
    <div className={classes.section}>
      <div className={classes.appContainer}>
        {APPS.map((app) => {
          return app.current ? (
            <AppLink key={app.name} app={app} classes={classes} />
          ) : (
            <a key={app.name} href={app.link}>
              <AppLink key={app.name} app={app} classes={classes} />
            </a>
          );
        })}
      </div>

      <hr className={classes.break} />

      <div className={classes.appContainer}>
        {INTEGRATIONS.map((integration) => {
          return integration.current ? (
            <AppLink
              key={integration.name}
              app={integration}
              classes={classes}
            />
          ) : (
            <a key={integration.name} href={integration.link}>
              <AppLink
                key={integration.name}
                app={integration}
                classes={classes}
              />
            </a>
          );
        })}
      </div>
    </div>
  );
};

AppSwitch.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(AppSwitch);
